<template>
  <a-button
    icon="book"
    size="small"
    type="link"
    @click="e => $emit('click', e)"
    style="color: #faad14"
  >
    跳转工单
  </a-button>
</template>

<script>
export default {
  name: 'JumpToTicketButton'
}
</script>
